<div
  *ngIf="columnSizes"
  [attr.id]="module.slug || null"
  [attr.data-ancnav]="module.slug || null"
  class="content-module multi-column-module"
  [attr.data-columns-format]="module.format"
>

  <div
    *ngFor="let column of columnSizes; let i = index"
    [class]="'multi-column__column multi-column__column-' + (i + 1)"
    [attr.data-column-format]="column"
  >
    <ng-container *ngFor="let module of module['column' + (i + 1)]">
      <app-links-module *ngIf="module.type === 'tableOfContents'" [module]="module"></app-links-module>
      <app-image *ngIf="module.type === 'media'" [module]="module"></app-image>
      <app-video *ngIf="module.type === 'youtube'" [module]="module"></app-video>
      <app-text *ngIf="module.type === 'text'" [module]="module"></app-text>
    </ng-container>
  </div>

</div>
